<template>
    <div>
        <!-- section start -->
        <section>
            <div class="inner row3 flex">
                <article class="wd50">
                    <div class="aRow3 trendSection1">
                        <h1>기업 네트워킹</h1>
                        <p>
                            <strong>
                                B2B(Business-to-Business) Matchmaking이란?
                            </strong>
                        </p>
                        <p>
                            체계화된 기업 네트워크로서 사업 목표 및 기대가 일치하는 기업을 연결해주고 기업의 수요에 따른 맞춤형 파트너쉽 연결을 제공하는 서비스입니다. B2B에는 기업, 연구기관,
                            대학, 협회, 지방자치단체 및 정부가 모두 포함되어 있습니다.
                        </p>
                        <div class="rowBtn2">
                            <a class="mainBgBtn btnFont" href="https://newagingplatform.com/" target="_blank">시작하기</a>
                        </div>
                    </div>
                </article>
                <article class="wd50 mobileReset">
                    <div class="alignR">
                        <figure>
                            <img src="../../assets/images/cmmnMain/기업네트워킹img.png" alt="기업네트워킹 이미지">
                        </figure>
                    </div>
                </article>
            </div>
        </section>

        <section>
            <div class="inner row2">
                <h1 class="mainTitle">서비스 이용방법</h1>
                <article class="mobileReset">
                    <div class="tabs" style="position: relative;">
                        <div class="tabContent">
                            <div v-show="currentTab == 0">
                                <UsedService :id=0 />
                            </div>
                            <div v-show="currentTab == 1">
                                <UsedService :id=1 />
                            </div>
                            <div v-show="currentTab == 2">
                                <UsedService :id=2 />
                            </div>
                            <div v-show="currentTab == 3">
                                <UsedService :id=3 />
                            </div>
                            <div v-show="currentTab == 4">
                                <UsedService :id=4 />
                            </div>
                            <div v-show="currentTab == 5">
                                <UsedService :id=5 />
                            </div>
                            <div v-show="currentTab == 6">
                                <UsedService :id=6 />
                            </div>
                            <div v-show="currentTab == 7">
                                <UsedService :id=7 />
                            </div>
                            <!-- <div class="uniqueBox" v-show="currentTab == 3">
                                <div class="flex">
                                    <div class="uniqueLeft flex">
                                        <div class="leftContent">
                                            <figure class="usedServiceImgBox">
                                                <img src="../../assets/images/cmmnMain/UsedService/직접매칭아이콘.png" alt="source img">
                                                <figcaption>
                                                    직접 매칭
                                                </figcaption>
                                            </figure>
                                        </div>
                                        <div class="rightContent">
                                            <p>
                                                <strong>
                                                    다양한 고령친화산업 또는 관심 기업들을 찾아보십시오.
                                                </strong>
                                            </p>
                                            <p>
                                                기업의 미충족 수요(unmet needs)를 해결하고 목표(goal) 달성에 필요한 기업을 추천해 드립니다. 추천 서비스 이외에도 검색필터를 통해 원하는 기업을 직접 검색해보실 수 있습니다.
                                            </p>
                                        </div>
                                    </div>
                                    <div class="uniqueRight flex">
                                        <div class="leftContent">
                                            <figure class="usedServiceImgBox">
                                                <img src="../../assets/images/cmmnMain/UsedService/플랫폼자문아이콘.png" alt="source img">
                                                <figcaption>
                                                    뉴에이징<br>플랫폼 자문
                                                </figcaption>
                                            </figure>
                                        </div>
                                        <div class="rightContent">
                                            <p>
                                                <strong>
                                                    선택한 기업이 적합한지 뉴에이징 플랫폼에서 의견 또는 자문을 드립니다.
                                                </strong>
                                            </p>
                                            <p>
                                                기업의 미충족 수요(unmet needs)와 목표(goal) 달성에 보다 나은 선택을 할 수 있도록 기업에 대해 고령친화산업 전문가의 의견 또는 자문을 제공해드립니다. (*메치메이킹 의견 및 자문은 선택사항입니다.)
                                            </p>
                                        </div>
                                    </div>
                                </div>
                                
                            </div> -->
                            <!-- <div v-show="currentTab == 4">
                                <UsedService :id=3 />
                            </div>
                            <div v-show="currentTab == 5">
                                <UsedService :id=4 />
                            </div>
                            <div v-show="currentTab == 6">
                                <UsedService :id=5 />
                            </div> -->
                        </div>
                        <button class="slideBtn left" @click="onClickPageMove('L')">

                        </button>
                        <button class="slideBtn right" @click="onClickPageMove('R')">

                        </button>
                    </div>
                    <div class="tabMenu mobileReset">
                        <ul>
                            <li v-for="(tab, index) in tabs" v-bind:class="{ active: currentTab === index }"
                                v-bind:key="tab" v-on:click="currentTab = index">
                                <span> {{ tab }} </span>
                            </li>
                        </ul>
                    </div>
                </article>
                <div class="mobileUseServiced">
                    <div>
                        <UsedService :id=0 />
                    </div>
                    <div>
                        <UsedService :id=1 />
                    </div>
                    <div>
                        <UsedService :id=2 />
                    </div>
                    <div>
                        <UsedService :id=3 />
                    </div>
                    <!-- <div>
                        <div class="flex mobileFlex serviceContent corpNoClass04">
                            <div class="uniqueLeft flex mobileFlex">
                                <div class="leftContent">
                                    <figure class="usedServiceImgBox">
                                        <img src="../../assets/images/cmmnMain/UsedService/직접매칭아이콘.png" alt="source img">
                                        <figcaption>
                                            직접 매칭
                                        </figcaption>
                                    </figure>
                                </div>
                                <div class="rightContent">
                                    <p>
                                        <strong>
                                            다양한 고령친화산업 또는 관심 기업들을 찾아보십시오.
                                        </strong>
                                    </p>
                                    <p>
                                        기업의 미충족 수요(unmet needs)를 해결하고 목표(goal) 달성에 필요한 기업을 추천해 드립니다. 추천 서비스 이외에도 검색필터를 통해 원하는 기업을 직접 검색해보실 수 있습니다.
                                    </p>
                                </div>
                            </div>
                            <div class="uniqueRight flex mobileFlex">
                                <div class="leftContent">
                                    <figure class="usedServiceImgBox">
                                        <img src="../../assets/images/cmmnMain/UsedService/플랫폼자문아이콘.png" alt="source img">
                                        <figcaption>
                                            뉴에이징<br>플랫폼 자문
                                        </figcaption>
                                    </figure>
                                </div>
                                <div class="rightContent">
                                    <p>
                                        <strong>
                                            선택한 기업이 적합한지 뉴에이징 플랫폼에서 의견 또는 자문을 드립니다.
                                        </strong>
                                    </p>
                                    <p>
                                        기업의 미충족 수요(unmet needs)와 목표(goal) 달성에 보다 나은 선택을 할 수 있도록 기업에 대해 고령친화산업 전문가의 의견 또는 자문을 제공해드립니다. (*메치메이킹 의견 및 자문은 선택사항입니다.)
                                    </p>
                                </div>
                            </div>
                        </div>
                        
                    </div> -->
                    <div>
                        <UsedService :id=4 />
                    </div>
                    <div>
                        <UsedService :id=5 />
                    </div>
                    <div>
                        <UsedService :id=6 />
                    </div>
                    <div>
                        <UsedService :id=7 />
                    </div>
                </div>

                <div class="mobileTop mobileBlock">
                    <button>
                        <img src="../../assets/images/Btn/맨위로가기버튼.png" alt="">
                    </button>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
import UsedService from '@/components/layout/UsedService/UsedService'

export default {
    name: 'corpNetworking',
    components: {
        UsedService
    },
    data() {
        return {
            currentTab: 0,
            tabs: ['1', '2', '3', '4', '5', '6', '7', '8'],
        }
    },
    methods: {
        onClickPageMove(d) {
            if (d === 'L') {
                this.currentTab = this.currentTab - 1
                if (this.currentTab == -1) this.currentTab = this.tabs.length - 1
            }
            else if (d === 'R') {
                this.currentTab = this.currentTab + 1
                if (this.currentTab == this.tabs.length) this.currentTab = 0
            }
        }
    }
}

</script>

<style scoped>
.topMenu ul li.active:after {
    content: '';
    position: absolute;
    width: 120%;
    height: 7px;
    bottom: 0;
    left: 50%;
    transform: translateX(-50%);
    background: #26336A;
}

.tabMenu ul li {
    cursor: pointer;
}

.uniqueBox .uniqueLeft {
    width: 50%;
    padding: 0 15px 0 0;
}

.uniqueBox .uniqueRight {
    width: 50%;
    padding: 0 0 0 15px;
}

.uniqueLeft .leftContent {
    width: 143px;
}

.uniqueLeft .rightContent {
    width: calc(100% - 143px);
    padding: 0 26px;
}

.uniqueRight .leftContent {
    width: 143px;
}

.uniqueRight .rightContent {
    width: calc(100% - 143px);
    padding: 0 26px;
}

.uniqueRight .leftContent figcaption {
    line-height: 40px;
    white-space: nowrap;
}

.tabMenu {
    position: relative;
    text-align: center;
    padding: 40px 0;
    margin-bottom: 60px;
}

.tabMenu ul li {
    display: inline-block;
    font-size: 26px;
    border: 1px solid #272727;
    border-radius: 20px;
    width: 40px;
    height: 40px;
    margin: 0 10px;
    line-height: 35px;
}

.tabMenu ul li.active {
    background-color: #26336A;
    color: #FFF;
}

@media screen and (max-width: 560px) {
    .uniqueLeft .leftContent {
        width: 100%;
    }

    .uniqueLeft .rightContent {
        width: 100%;
        padding: 0;
        margin: 0 0 50px 0;
    }

    .uniqueLeft .rightContent p {
        text-align: center;
    }

    .uniqueLeft .rightContent p:first-child {
        margin: 0 0 20px 0;
    }

    .uniqueRight .leftContent {
        width: 100%;
    }

    .uniqueRight .rightContent {
        width: 100%;
        padding: 0;
        margin: 0 0 50px 0;
    }

    .uniqueRight .rightContent p {
        text-align: center;
    }

    .uniqueRight .rightContent p:first-child {
        margin: 0 0 20px 0;
    }
}
</style>

<style></style>

